import React from "react";
import {Title} from "@mantine/core";
import Translation from "../Utils/Translation";
import PunchingKnifeList from "../List/PunchingKnifeList";
import CheckPrivilege from "../Utils/CheckPrivilege";
export default () => <CheckPrivilege component="PunchingKnife">
    <Title order={1}>
        <Translation id="punchingKnives" />
    </Title>
    <PunchingKnifeList listId="punchingKnives" />
</CheckPrivilege>;
